export const formatVideoDuration = (duration: number): string => {
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor((duration % 3600) / 60)
  const seconds = Math.floor(duration % 60)

  const paddedHours = hours < 10 ? `0${hours}` : `${hours}`
  const paddedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
  const paddedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`

  return hours > 0
    ? `${paddedHours}:${paddedMinutes}:${paddedSeconds}`
    : `${paddedMinutes}:${paddedSeconds}`
}
